export enum Status {
  Enable = 1,
  Disable = 2,
}

export enum StatusText {
  Enable = 'enable',
  Disable = 'disable',
}
